import React, { FC, useRef } from 'react';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';

interface EllipsisMenuProps {
    items: any[];
}
const EllipsisMenu:FC<EllipsisMenuProps> = ({items}) => {
    const menu = useRef(null);

    return (
        <div>
            <Menu model={items} popup ref={menu} />
            <Button 
                icon="pi pi-ellipsis-v" 
                className="p-button-rounded p-button-text" 
                onClick={(e) => menu.current.toggle(e)} 
            />
        </div>
    );
};

export default EllipsisMenu;
